import { Box, Checkbox, FormControlLabel, FormHelperText } from '@mui/material'
import { TemplateInfo } from '../../api/types'
import { SectionCard } from '../../components/SectionCard'

interface ImperiumDocumentsSectionProps {
  templates: TemplateInfo[]
  selectedKeys: string[]
  onChange: (keys: string[]) => void
  error?: string
}

/** Imperium: checklist dokumentů ke generování (vzor staré ImperiumDocumentForm). */
export function ImperiumDocumentsSection({
  templates,
  selectedKeys,
  onChange,
  error,
}: ImperiumDocumentsSectionProps) {
  const toggle = (key: string) => {
    onChange(
      selectedKeys.includes(key)
        ? selectedKeys.filter((item) => item !== key)
        : [...selectedKeys, key]
    )
  }

  const toggleAll = () => {
    onChange(selectedKeys.length === templates.length ? [] : templates.map((t) => t.key))
  }

  return (
    <SectionCard title="Dokumenty k vygenerování">
      <FormControlLabel
        control={
          <Checkbox
            checked={templates.length > 0 && selectedKeys.length === templates.length}
            indeterminate={selectedKeys.length > 0 && selectedKeys.length < templates.length}
            onChange={toggleAll}
          />
        }
        label="Vybrat vše"
      />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
        }}
      >
        {templates.map((template) => (
          <FormControlLabel
            key={template.key}
            control={
              <Checkbox
                checked={selectedKeys.includes(template.key)}
                onChange={() => toggle(template.key)}
              />
            }
            label={template.staticPdf ? `${template.label} (statické PDF)` : template.label}
          />
        ))}
      </Box>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </SectionCard>
  )
}
